
// Import React and various components for the home page
import React from "react";
import Headers from "../Header/Headers";
import SubcriptionSection from "./SubcriptionSection";
import "./Home.css";
import MeetCoach from "./MeetCoach";
import RecompPresent from "./RecompPresent";
import RealResult from "./RealResult";
import HappyClient from "./HappyClient";
import ChooseProgram from "./chooseProgram";
import Testimonial from "./Testimonial";
import SystemStory from "./SystemStory";
import Motivation from "./Motivation";
import FinalCTA from "./FinalCTA";
import UrgencyStrip from "./UrgencyStrip";

// Home component to render the main page structure
const Home = () => {
  return (
    <>
      {/* Render the header section */}
      <Headers />
      {/* Render the motivation section */}
      <Motivation />
      {/* Render the happy client section with image gallery */}
      <HappyClient />
      {/* Render the meet coach section */}
      <MeetCoach />
      {/* Render the real results section with transformation images */}
      <RealResult />
      {/* Render the recomp present section */}
      <RecompPresent />
      {/* Render the choose program section */}
      <ChooseProgram />
      {/* Render the subscription section */}
      <SubcriptionSection />
      {/* Render the system story section */}
      <SystemStory />
      {/* Render the testimonial section */}
      <Testimonial />
      {/* Render the final call-to-action section */}
      <FinalCTA />
      {/* Render the urgency strip section */}
      <UrgencyStrip />
      {/* Footer component is commented out, not currently rendered */}
      {/* <Footer /> */}
    </>
  );
};

// Export the Home component
export default Home;